import './index.scss'

const InputLabel = ({name, label, information}) => (
    <div className='label'>
    <label htmlFor={name} >
        {label}
    </label>
    {information && <p className='input-label__information'>What is this?</p>/* TODO: add popup for informaiton*/} 
</div>
)

export default InputLabel;